import { INSTRUCTOR_RELEASE_UNSET_LABEL } from '../../../consts/messages'

export const formatSectionReleaseDateCell = (
  value: string | null | undefined,
  options: { isInstructorColumn: boolean, isGradePostingReleaseEnabled: boolean }
): string => {
  if (value) return value
  if (options.isGradePostingReleaseEnabled && options.isInstructorColumn) return INSTRUCTOR_RELEASE_UNSET_LABEL
  return '-'
}
